import React, { useState } from 'react';
import AnimatedButton from '../components/AnimatedButton';
import '../styles/RoboticsBanner.css'
import AnimatedArrowButton from './AnimatedArrowButton';



const RoboticsBanner = () => {


    return(<div className='robotics-banner'>
        <div className='banner_bg'>
        <h1>Robotics That Work Alongside Humans</h1>
        <div className='banner-container'>
            <div className='banner-box box1'>
            Revolutionizing Automation – Robotics That Work Alongside Humans
            </div>
            <div className='banner-box box2'>
            Explore cutting-edge solutions for manufacturing, healthcare, logistics, and more.
            </div>

        </div>
        <div className='button-box' style={{display:'none'}}>
        <AnimatedArrowButton text="Explore Now" link="https://example.com" />
        </div>
        </div>
    </div>);


}

export default RoboticsBanner;